import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveConstraintRequestFailure(constraintId) {
      const req = getState().find((req) => req.constraintId === constraintId);

      return req ? req.request.isFailure : false;
    },
    isRetrieveConstraintRequestPending(constraintId) {
      const req = getState().find((req) => req.constraintId === constraintId);

      return req ? req.request.isPending : false;
    },
    isRetrieveConstraintRequestSuccess(constraintId) {
      const req = getState().find((req) => req.constraintId === constraintId);

      return req ? req.request.isSuccessful : false;
    },
    getConstraint(constraintId) {
      const req = getState().find((req) => req.constraintId === constraintId);

      return req ? req.constraint : undefined;
    },
  };
}

export { createSelector };
